import { Vue, Prop, Watch, Component } from 'vue-property-decorator';
import CornerMark from './cornerMark';
import CreateCorner from '@/views/pages/createCorner/createCorner';

@Component({
  components: {
    CornerMark,
    CreateCorner,
  },
})
export default class Index extends Vue {
  isEdit = false;

  tagId = null;
  statusType = null;

  onStatusChange(status, params) {
    if (status === 'edit' || status === 'create') {
      this.tagId = params.tagId;
      this.statusType = params.type;

      this.$nextTick(() => {
        this.isEdit = true;
      });
    }
  }

  /**
   *
   * @param edit 是否是编辑的保存
   */
  onDetailChange(edit) {
    this.isEdit = false;
  }

  render(h) {
    return this.isEdit ? <CreateCorner tagId={this.tagId} pageType={this.statusType} on-detail={this.onDetailChange.bind(this)} /> : <CornerMark on-status={this.onStatusChange.bind(this)} />;
  }
}
